import { render, staticRenderFns } from "./SearchManager.vue?vue&type=template&id=aba87bc4&scoped=true&"
import script from "./SearchManager.vue?vue&type=script&lang=ts&"
export * from "./SearchManager.vue?vue&type=script&lang=ts&"
import style0 from "./SearchManager.vue?vue&type=style&index=0&id=aba87bc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aba87bc4",
  null
  
)

export default component.exports
import {QSelect,QItemLabel,QItem,QItemSection} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QSelect,QItemLabel,QItem,QItemSection})
